import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Titles from './pages/Titles';
import TitleDetail from './pages/TitleDetail';
import Subscribers from './pages/Subscribers';
import SubscriberDetail from './pages/SubscriberDetail';
import Editions from './pages/Editions';
import Renewals from './pages/Renewals';
import Settings from './pages/Settings';
import './App.css';

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="titles" element={<Titles />} />
        <Route path="titles/:id" element={<TitleDetail />} />
        <Route path="subscribers" element={<Subscribers />} />
        <Route path="subscribers/:id" element={<SubscriberDetail />} />
        <Route path="editions" element={<Editions />} />
        <Route path="renewals" element={<Renewals />} />
        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
